import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/files'
const plural = 'downloads'
const single = 'download'

const download = new ApiCore({
    create: true,
	url: url,
	plural: plural,
	single: single
})

download.download = (id, options) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${id}`, options)
		.then(handleResponse)
		.catch(handleError);
}

download.downloadFiles = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/download`, payload)
		.then(handleResponse)
		.catch(handleError);
}



export default download
